// extracted by mini-css-extract-plugin
export default {"form-module":"AddVideo_form-module__CW+Nv","input-field":"AddVideo_input-field__RrXvk","search-icon":"AddVideo_search-icon__QWWP3","error":"AddVideo_error__RwyZ9"};